import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const DiamondIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path d="M19.5 2H4.5L1 8L12 21.5L23 8L19.5 2Z" fill={getColor(secondaryColor)} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9994 22.8642C11.7388 22.8642 11.4926 22.7446 11.3314 22.5398L0.214055 8.40826C0.0128027 8.15245 -0.02469 7.80416 0.117505 7.51137C0.259699 7.21858 0.556611 7.0327 0.882103 7.0327L23.1168 7.0327C23.4423 7.0327 23.7392 7.21858 23.8814 7.51137C24.0236 7.80416 23.9861 8.15244 23.7848 8.40826L12.6675 22.5398C12.5063 22.7446 12.2601 22.8642 11.9994 22.8642ZM21.3666 8.7327L2.63231 8.73271L11.9994 20.6395L21.3666 8.7327Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.58449 1.50343C3.73634 1.24047 4.01693 1.07849 4.32058 1.07849H19.6786C19.9822 1.07849 20.2628 1.24047 20.4146 1.50343L23.853 7.45765C24.0049 7.72064 24.0049 8.04467 23.8531 8.30768C23.7012 8.57069 23.4206 8.73271 23.1169 8.73271H0.882227C0.578538 8.73271 0.29792 8.57069 0.146087 8.30768C-0.00574642 8.04467 -0.0057255 7.72064 0.146142 7.45765L3.58449 1.50343ZM4.81128 2.77849L2.35462 7.03271H21.6445L19.1879 2.77849H4.81128Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.14818 1.80569L9.69554 2.50974L7.23924 7.9082L12.8331 21.7531L11.2569 22.3899L5.38965 7.86841L8.14818 1.80569Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7532 1.80569L14.2058 2.50974L16.6621 7.9082L11.0682 21.7531L12.6444 22.3899L18.5117 7.86841L15.7532 1.80569Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default DiamondIconFilled;
